import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// TODO: Import @material-ui from design-system folder
// eslint-disable-next-line restrict-imports/restrict-imports
import IconButton from '@material-ui/core/IconButton';

// X button for deleting something
interface XButtonProps {
  onClick: Function;
}
export const XButton: React.FC<XButtonProps> = ({ onClick }) => {
  return (
    <IconButton edge="start" color="inherit" onMouseDown={() => onClick()}>
      <FontAwesomeIcon
        style={{ width: 16, height: 16, cursor: 'pointer', opacity: 0.75 }}
        icon="trash"
      />
    </IconButton>
  );
};
